import React, { useState, useEffect } from 'react';
import { Col, Button, Row, Spinner, Input } from 'reactstrap';
import { ComponentCard } from '../layout/ComponentCard';
import { Loader } from '../layout/Loader';
import { Desplegable } from './Desplegable';
import { Instancia } from '../helpers/axios';
import logger from '../../../services/logger/logger';
import { convocatoriasAgotadas } from '../../../helpers/convocatorias';
import {
  isSintesisOFCT,
  withDefaultTramoGrouped,
  inicioPorTramo,
  precioInscripcionSegunSeleccion,
} from '../../../helpers/actividades';

export const ActividadesGrupos = ({
  local,
  userSession,
  previous,
  next,
  id,
  modulos,
  beginning,
  empresaId,
  nombreGrupo,
  setModulos,
  variant,
  deployment,
  sumatorio,
  sumatorio2,
  sumatorioSuelto,
  sumatorioSuelto2,
  setActividades,
  setIsSede,
  setPrecioFinal,
  precioFinal,
  descuento,
  setPrecioCompleto,
  mode,
}) => {
  // En presupuesto el alumno puede ser un lead puro (isLead=true) o un alumno
  // ya existente (isLead=false). Si la flag no está en storage por compat,
  // se asume `true` en presupuesto, false en matrícula.
  const isLeadFlag =
    mode === 'presupuesto' ? (local.isLead === undefined ? true : !!local.isLead) : false;
  const leadParam = isLeadFlag ? '&isLead=true' : '';
  // Preparamos variables necesarias
  const [activity, setActivity] = useState({});
  const [isEnabled, setIsEnabled] = useState(true);
  const [isAllCheked, setIsAllCheked] = useState(false);
  const [hoursCounter, setHoursCounter] = useState(0);
  const [dataPrecio, setDataPrecio] = useState([]);
  const [total, setTotal] = useState(sumatorio);
  const [totalSuelto, setTotalSuelto] = useState(sumatorioSuelto);
  const [total2, setTotal2] = useState(sumatorio2);
  const [totalSuelto2, setTotalSuelto2] = useState(sumatorioSuelto2);
  const [isLoading, setIsLoading] = useState(true);

  const [, setIsNewStudent] = useState(false);
  // Arrastre de actividades anuales (sin T1/T2) hacia un bloque concreto
  const [draggedItem, setDraggedItem] = useState(null);
  const [dragOverInicio, setDragOverInicio] = useState(null);
  const isNoPresencial = nombreGrupo.includes('NP');
  const fullName = `${local.nombre} ${local.apellidos}`;
  function verificarTodosCursos(cursos, anio, lista) {
    // Obtener los cursos del año especificado
    const cursosFiltrados = Object.values(cursos)
      .flat()
      .filter((curso) => curso.curso === anio)
      .map((curso) => `${curso.modulo} ${curso.descripcion}`);

    // Verificar si todos los cursos están en la lista
    return cursosFiltrados.every((curso) => lista.includes(curso));
  }

  const allFirstYearChecked = verificarTodosCursos(activity, 'PRIMERO', modulos);
  const allSecondYearChecked = verificarTodosCursos(activity, 'SEGUNDO', modulos);

  useEffect(() => {
    let precio = 0;
    if (allFirstYearChecked && allSecondYearChecked) {
      precio = total + total2;
    } else if (!allFirstYearChecked && allSecondYearChecked) {
      precio = totalSuelto + total2;
    } else if (allFirstYearChecked && !allSecondYearChecked) {
      precio = total + totalSuelto2;
    } else {
      precio = totalSuelto + totalSuelto2;
    }
    setPrecioFinal(precio);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allFirstYearChecked, allSecondYearChecked, total, total2, totalSuelto, totalSuelto2]);

  // Efectos
  useEffect(() => {
    peticionesApi();
  }, []);

  // Función para las peticiones a API
  const peticionesApi = async () => {
    // Salvaguarda: si todavía no tenemos alumno/lead o grupo, no llamamos al
    // backend con `id=` vacío (provoca 400 en /buscarPreciosCiclo).
    if (!local?.id || !id) return;

    // Declaramos instancia de axios
    const instance = Instancia(deployment);

    const grupos = await instance.get(
      `nuevoEstudiante?headquarter=${empresaId}&userEmail=${userSession?.profileObj.email}&id=${local.id}&name=${nombreGrupo}${leadParam}`,
    );

    setIsNewStudent(grupos.data.estado);

    // peticiones a la API
    try {
      // Petición para obtener módulos
      const actualActivity = await instance.get(
        `buscarModulos?groupId=${id}&headquarter=${empresaId}&userEmail=${userSession?.profileObj.email}&studentId=${local.id}&newMat=1&nuevo=${grupos.data.estado}${leadParam}`,
      );
      const actividadesConTramoDefault = withDefaultTramoGrouped(actualActivity.data);
      setActivity(actividadesConTramoDefault);
      setActividades(actividadesConTramoDefault);
      // Petición para obtener el precio del curso
      const precioCurso = await instance.get(
        `buscarPreciosCiclo?headquarter=${empresaId}&userEmail=${userSession?.profileObj.email}&id=${local.id}&groupId=${id}&descuento=${descuento.id}&nuevo=${grupos.data.estado}${leadParam}`,
      );
      setDataPrecio(precioCurso.data);
      setIsSede(precioCurso.data[0].tipo === 'sede');
      setPrecioCompleto(precioCurso.data[0].precioCiclo);
      setIsLoading(false);
    } catch (error) {
      // Si se produce un error, lo registramos sin recargar para evitar loop infinito
      logger.error('Error en ActividadesGrupos:', error);
      sessionStorage.setItem('apiError', error);
    }

    if (modulos.length > 0) {
      setIsEnabled(false);
    }
  };

  // Función para seleccionar todos los módulos
  const marcarTodos = () => {
    let hours = 0;
    let sumTot = 0;
    let sumTotSuelto = 0;
    let sumTot2 = 0;
    let sumTotSuelto2 = 0;

    Object.entries(activity).forEach(([, array]) => {
      array.forEach((obj) => {
        const value = `${obj.modulo} ${obj.descripcion}`;

        if (!modulos.includes(value) && Number(obj.Nota) !== 1) {
          const newArr = modulos;
          newArr.push(value);
          setModulos([...newArr]);
          if (obj.curso === 'PRIMERO') {
            sumTot += obj.precio;
            sumTotSuelto += obj.importe_suelto;
          } else {
            sumTot2 += obj.precio;
            sumTotSuelto2 += obj.importe_suelto;
          }

          if (!obj.descripcion.includes('Formación en el centro de trabajo')) {
            if (!obj.descripcion.includes('Formación en centros de trabajo')) {
              const notaAsInt = parseInt(obj.horas !== null ? obj.horas.toString() : '0', 10);
              hours = hours + notaAsInt;
            }
          }
        }
      });
    });

    setIsEnabled(false);
    setIsAllCheked(true);
    setHoursCounter(hours);
    setTotal(sumTot);
    setTotal2(sumTot2);
    setTotalSuelto(sumTotSuelto);
    setTotalSuelto2(sumTotSuelto2);
  };

  // Función para desmarcar todos los módulos
  const desmarcarTodos = () => {
    const newArr = modulos;
    newArr.splice(0, modulos.length);
    setModulos([...newArr]);

    setIsEnabled(true);
    setIsAllCheked(false);
    setHoursCounter(0);
    setTotal(0);
    setTotal2(0);
    setTotalSuelto2(0);
    setTotalSuelto(0);
  };

  // Helpers para la vista de 3 columnas en modo presupuesto
  const itemKey = (item) => `${item.modulo} ${item.descripcion}`;
  const allItems = Object.values(activity).flat();
  const getInicio = (item) => {
    const i = (item.Inicio || '').toLowerCase();
    if (i) {
      if (i.includes('feb')) return 'febrero';
      return 'septiembre';
    }
    // Si Inicio es null/vacío, fallback al tramo: T2 -> febrero, T1 -> septiembre
    const t = (item.tramo || '').toUpperCase();
    if (t === 'T2') return 'febrero';
    return 'septiembre';
  };
  const availableItems = allItems.filter((it) => !modulos.includes(itemKey(it)));
  const septiembreItems = allItems.filter(
    (it) => modulos.includes(itemKey(it)) && getInicio(it) === 'septiembre',
  );
  const febreroItems = allItems.filter(
    (it) => modulos.includes(itemKey(it)) && getInicio(it) === 'febrero',
  );

  const recalcularTotales = (seleccionados) => {
    let h = 0;
    let t = 0;
    let ts = 0;
    let t2 = 0;
    let ts2 = 0;
    allItems.forEach((item) => {
      if (!seleccionados.includes(itemKey(item))) return;
      if (item.Nota === 1) return;
      if (item.curso === 'PRIMERO') {
        t += item.precio;
        ts += item.importe_suelto;
      } else {
        t2 += item.precio;
        ts2 += item.importe_suelto;
      }
      if (
        !item.descripcion.includes('Formación en el centro de trabajo') &&
        !item.descripcion.includes('Formación en centros de trabajo')
      ) {
        h += parseInt(item.horas != null ? item.horas.toString() : '0', 10);
      }
    });
    setHoursCounter(h);
    setTotal(t);
    setTotal2(t2);
    setTotalSuelto(ts);
    setTotalSuelto2(ts2);
  };

  const handleTramoChange = (item, nuevoTramo) => {
    const inicio = inicioPorTramo(nuevoTramo);
    const matches = (it) => it.codigo === item.codigo && it.descripcion === item.descripcion;
    const updateGrouped = (prev) => {
      const updated = {};
      Object.entries(prev).forEach(([k, arr]) => {
        updated[k] = arr.map((it) => (matches(it) ? { ...it, tramo: nuevoTramo, Inicio: inicio } : it));
      });
      return updated;
    };
    setActivity(updateGrouped);
    setActividades(updateGrouped);
  };

  const togglePresupuestoItem = (item) => {
    if (item.Nota === 1 || convocatoriasAgotadas(item)) return;
    const value = itemKey(item);
    const nuevos = modulos.includes(value)
      ? modulos.filter((m) => m !== value)
      : [...modulos, value];
    setModulos(nuevos);
    recalcularTotales(nuevos);
    setIsEnabled(nuevos.length === 0);
  };

  // Las T1/T2 (y Síntesis/FCT, que siempre llevan tramo) se autoasignan con clic.
  // Las anuales (sin tramo T1/T2) no se autoasignan: el usuario las arrastra al bloque.
  const isAnual = (item) => {
    const t = (item.tramo || '').toUpperCase();
    return t !== 'T1' && t !== 'T2';
  };

  // Asigna (o reubica) una actividad a un bloque concreto fijando su Inicio.
  const asignarAInicio = (item, inicio) => {
    if (item.Nota === 1 || convocatoriasAgotadas(item)) return;
    const matches = (it) => it.codigo === item.codigo && it.descripcion === item.descripcion;
    const updateGrouped = (prev) => {
      const updated = {};
      Object.entries(prev).forEach(([k, arr]) => {
        updated[k] = arr.map((it) => (matches(it) ? { ...it, Inicio: inicio } : it));
      });
      return updated;
    };
    setActivity(updateGrouped);
    setActividades(updateGrouped);
    const value = itemKey(item);
    if (!modulos.includes(value)) {
      const nuevos = [...modulos, value];
      setModulos(nuevos);
      recalcularTotales(nuevos);
      setIsEnabled(nuevos.length === 0);
    }
  };

  const handleDragStart = (item) => (e) => {
    setDraggedItem(item);
    e.dataTransfer.effectAllowed = 'move';
    try {
      e.dataTransfer.setData('text/plain', itemKey(item));
    } catch {
      /* algunos navegadores requieren setData; si falla, seguimos con el estado */
    }
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
    setDragOverInicio(null);
  };

  const handleDropInicio = (inicio) => (e) => {
    e.preventDefault();
    setDragOverInicio(null);
    if (draggedItem) asignarAInicio(draggedItem, inicio);
    setDraggedItem(null);
  };

  const tramoBadgeColor = (tramo) => {
    const t = (tramo || '').toUpperCase();
    if (t === 'T1') return '#2563eb';
    if (t === 'T2') return '#7c3aed';
    return '#059669';
  };

  const cursoLabel = (curso) => {
    const c = (curso || '').toUpperCase();
    if (c === 'PRIMERO') return '1er año';
    if (c === 'SEGUNDO') return '2º año';
    return curso || '';
  };
  const cursoColor = (curso) => {
    const c = (curso || '').toUpperCase();
    if (c === 'PRIMERO') return '#0891b2';
    if (c === 'SEGUNDO') return '#ea580c';
    return '#6b7280';
  };

  const chipStyle = (color) => ({
    fontSize: '0.65rem',
    fontWeight: 600,
    padding: '2px 6px',
    borderRadius: '4px',
    backgroundColor: `${color}20`,
    color,
    whiteSpace: 'nowrap',
  });

  const renderModuloCard = (item) => {
    const disabled = item.Nota === 1 || convocatoriasAgotadas(item);
    const anual = isAnual(item);
    const seleccionado = modulos.includes(itemKey(item));
    const draggable = anual && !disabled;
    // En disponibles, las anuales solo se asignan arrastrando (no por clic).
    const clicSinEfecto = !disabled && anual && !seleccionado;
    const handleCardClick = () => {
      if (clicSinEfecto) return;
      togglePresupuestoItem(item);
    };
    return (
      <div
        key={`${item.modulo}-${item.codigo}-${item.descripcion}`}
        role="button"
        tabIndex={0}
        draggable={draggable}
        onDragStart={draggable ? handleDragStart(item) : undefined}
        onDragEnd={draggable ? handleDragEnd : undefined}
        onClick={handleCardClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleCardClick();
          }
        }}
        title={clicSinEfecto ? 'Arrastra esta actividad anual al bloque que quieras' : undefined}
        style={{
          padding: '8px 10px',
          marginBottom: '6px',
          borderRadius: '6px',
          border: '1px solid #e5e7eb',
          backgroundColor: disabled ? '#f3f4f6' : '#fff',
          cursor: disabled ? 'not-allowed' : draggable ? 'grab' : 'pointer',
          opacity: disabled ? 0.6 : 1,
          fontSize: '0.8rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '6px', justifyContent: 'space-between' }}>
          <strong style={{ flex: 1 }}>
            {(item.nombre || item.modulo || '').split(' - ')[0].trim()}
          </strong>
          {isSintesisOFCT(item) ? (
            <div
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
              role="presentation"
            >
              <Input
                type="select"
                bsSize="sm"
                value={(item.tramo || 'T1').toUpperCase()}
                onChange={(e) => handleTramoChange(item, e.target.value)}
                style={{
                  width: '110px',
                  fontSize: '0.7rem',
                  padding: '2px 4px',
                  height: 'auto',
                }}
                aria-label="Tramo"
              >
                <option value="T1">T1 · Septiembre</option>
                <option value="T2">T2 · Febrero</option>
              </Input>
            </div>
          ) : item.tramo ? (
            <span style={chipStyle(tramoBadgeColor(item.tramo))}>{item.tramo}</span>
          ) : (
            clicSinEfecto && (
              <span style={chipStyle('#059669')} title="Arrástrala al bloque que quieras">
                Anual · arrastrar
              </span>
            )
          )}
        </div>
        {item.descripcion && (
          <div style={{ color: '#6b7280', fontSize: '0.72rem' }}>{item.descripcion}</div>
        )}
        <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
          {item.curso && (
            <span style={chipStyle(cursoColor(item.curso))}>{cursoLabel(item.curso)}</span>
          )}
          {item.horas != null && item.horas !== '' && (
            <span style={chipStyle('#475569')}>{item.horas}h</span>
          )}
          {item.precio != null && item.precio !== '' && (
            <span style={chipStyle('#059669')}>{(parseFloat(item.precio) || 0).toFixed(2)} €</span>
          )}
        </div>
      </div>
    );
  };

  const sumPrecio = (items) =>
    items.reduce((sum, it) => sum + (parseFloat(it.precio) || 0), 0);
  const sumHoras = (items) =>
    items.reduce((sum, it) => sum + (parseInt(it.horas, 10) || 0), 0);

  const renderColumna = (titulo, items, vacioMsg, mostrarTotal = false, inicioDrop = null) => {
    const isDropTarget = inicioDrop != null;
    const resaltado = isDropTarget && draggedItem != null && dragOverInicio === inicioDrop;
    return (
    <Col md="4">
      <div
        onDragOver={
          isDropTarget
            ? (e) => {
                e.preventDefault();
                e.dataTransfer.dropEffect = 'move';
                if (dragOverInicio !== inicioDrop) setDragOverInicio(inicioDrop);
              }
            : undefined
        }
        onDragLeave={
          isDropTarget
            ? () => setDragOverInicio((cur) => (cur === inicioDrop ? null : cur))
            : undefined
        }
        onDrop={isDropTarget ? handleDropInicio(inicioDrop) : undefined}
        style={{
          backgroundColor: resaltado ? '#eff6ff' : '#f9fafb',
          border: resaltado ? '2px dashed #2563eb' : '1px solid #e5e7eb',
          borderRadius: '8px',
          padding: '12px',
          minHeight: '300px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <h6 style={{ marginBottom: '12px', fontSize: '0.85rem', fontWeight: 700 }}>
          {titulo} ({items.length})
        </h6>
        <div style={{ flex: 1 }}>
          {items.length === 0 ? (
            <p style={{ color: '#9ca3af', fontSize: '0.75rem', margin: 0 }}>{vacioMsg}</p>
          ) : (
            items.map(renderModuloCard)
          )}
        </div>
        {mostrarTotal && (
          <div
            style={{
              marginTop: '12px',
              paddingTop: '8px',
              borderTop: '1px solid #e5e7eb',
              fontSize: '0.8rem',
              fontWeight: 600,
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
              <span style={{ color: '#374151' }}>Horas:</span>
              <span style={{ color: '#475569' }}>{sumHoras(items)} h</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#374151' }}>Sumatorio:</span>
              <span style={{ color: '#059669' }}>{sumPrecio(items).toFixed(2)} €</span>
            </div>
          </div>
        )}
      </div>
    </Col>
    );
  };

  return (
    <Col md="12">
      <ComponentCard
        title={`Módulos disponibles - ${empresaId}`}
        hasButton={false}
        className="clearfix"
        name={fullName}
      >
        {Object.keys(activity).length === 0 && dataPrecio.length === 0 ? (
          <Loader />
        ) : (
          <>
            <Row style={{ marginTop: '-20px', marginBottom: '8px' }}>
              <Col md="12">
                <b>{nombreGrupo}</b>
              </Col>
            </Row>
            <Row style={{ marginBottom: '24px' }}>
              <Col md="4">
                <b>
                  Precio inscripción:
                  {isLoading ? (
                    <Spinner style={{ marginLeft: '8px' }} color="primary" size="sm" />
                  ) : dataPrecio.length !== 0 ? (
                    // Matrícula completa (todos los módulos de 1er año) -> precio;
                    // selección parcial -> importe_suelto. Recalcula en vivo con la
                    // selección (allFirstYearChecked). El 2º año no cuenta.
                    ` ${precioInscripcionSegunSeleccion(dataPrecio, allFirstYearChecked)} €`
                  ) : (
                    ' 0 €'
                  )}
                </b>
              </Col>
              {!isLoading && dataPrecio.length > 0 && dataPrecio[0].precioCiclo > 0 && (
                <Col md="4">
                  <b>
                    Precio ciclo:
                    {isLoading ? (
                      <Spinner style={{ marginLeft: '8px' }} color="primary" size="sm" />
                    ) : (
                      ` ${dataPrecio[0].precioCiclo} €`
                    )}
                  </b>
                </Col>
              )}
              <Col md="4" style={{ textAlign: 'right' }}>
                <b>
                  Sumatorio:
                  {isLoading ? (
                    <Spinner style={{ marginLeft: '8px' }} color="primary" size="sm" />
                  ) : dataPrecio.length > 0 ? (
                    ` ${precioFinal} €`
                  ) : (
                    ' 0 €'
                  )}
                </b>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                {isAllCheked ? (
                  <Button className="me-1 mb-2" onClick={desmarcarTodos}>
                    <i className="bi bi-check-square" style={{ marginRight: '8px' }}></i>
                    Desmarcar todos
                  </Button>
                ) : (
                  <Button className="me-1 mb-2" onClick={marcarTodos}>
                    <i className="bi bi-check-square-fill" style={{ marginRight: '8px' }}></i>
                    Marcar todos
                  </Button>
                )}
              </Col>
            </Row>
            <div style={{ marginTop: '8px' }}>
              {mode === 'presupuesto' ? (
                <Row>
                  {renderColumna(
                    'Módulos disponibles',
                    availableItems,
                    'Todos los módulos están asignados a un periodo.',
                  )}
                  {renderColumna(
                    'Inicio Septiembre',
                    septiembreItems,
                    'Sin módulos en este periodo.',
                    true,
                    'septiembre',
                  )}
                  {renderColumna(
                    'Inicio Febrero',
                    febreroItems,
                    'Sin módulos en este periodo.',
                    true,
                    'febrero',
                  )}
                </Row>
              ) : (
                Object.entries(activity).map(([key, array]) => (
                  <Desplegable
                    key={key}
                    array={array}
                    activity={activity}
                    keyArray={key}
                    modulos={modulos}
                    setIsEnabled={setIsEnabled}
                    setModulos={setModulos}
                    setHoursCounter={setHoursCounter}
                    setTotal={setTotal}
                    total={total}
                    hoursCounter={hoursCounter}
                    totalSuelto={totalSuelto}
                    setTotal2={setTotal2}
                    setTotalSuelto2={setTotalSuelto2}
                    total2={total2}
                    totalSuelto2={totalSuelto2}
                    setTotalSuelto={setTotalSuelto}
                  />
                ))
              )}
            </div>

            {isNoPresencial && hoursCounter > 2000 ? (
              <small className="text-danger">
                Ha superado el máximo de horas disponibles. (505h sin contar FCT)
              </small>
            ) : (
              ''
            )}
            <div className="pt-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button onClick={previous}>Atrás</Button>
              <Button onClick={beginning}>
                {variant === 'portal' ? 'Volver a detalles' : 'Volver a la ficha de alumno'}
              </Button>
              <Button
                onClick={() => next(precioFinal)}
                disabled={isEnabled || (isNoPresencial && hoursCounter > 2000)}
              >
                Siguiente
              </Button>
            </div>
          </>
        )}
      </ComponentCard>
    </Col>
  );
};
